import React from 'react';
import './NotFound.css'

//Page to display for invalid URL path
const NotFound = () => {
    return (
        <div className="NotFound">
            The page you are looking for cannot be found.
        </div>
    )
}

export default NotFound;